module.exports = __webpack_public_path__ + "static/media/linkedin.c543b1b6.svg";